import { createSlice } from "@reduxjs/toolkit";

/**
 * Menu categories, and which one the boards are filtered to.
 *
 * `selected` is a category id, or the string 'All' for no filter. 'All' is a
 * sentinel and deliberately NOT a member of `categories` — an earlier version
 * pushed the word into the list itself, which meant every screen that drew the
 * list had to remember to filter it back out, and one of them forgot.
 */
const initialState = {
  categories: [],
  selected: "All",
  isCategoryDataFetched: false,
};

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = (action.payload || []).filter((category) => category && category._id);
    },

    setCategoryDataFetched: (state, action) => {
      state.isCategoryDataFetched = action.payload;
    },

    selectCategory: (state, action) => {
      state.selected = action.payload;
    },

    addCategory: (state, action) => {
      if (action.payload) state.categories.push(action.payload);
    },

    updateCategory: (state, action) => {
      const { _id, updated } = action.payload;
      const index = state.categories.findIndex((category) => category._id === _id);
      if (index !== -1) {
        state.categories[index] = { ...state.categories[index], ...updated };
      }
    },

    /** Filtering by a category that no longer exists would show nothing. */
    removeCategory: (state, action) => {
      state.categories = state.categories.filter((category) => category._id !== action.payload);
      if (state.selected === action.payload) state.selected = "All";
    },
  },
});

export const {
  setCategories,
  setCategoryDataFetched,
  selectCategory,
  addCategory,
  updateCategory,
  removeCategory,
} = categorySlice.actions;

export default categorySlice.reducer;
